/* NO販売店情報(一覧) */
import React, { useState, memo } from 'react';
import { Grid, _ } from 'gridjs-react';
import { no_store_list_index } from '../Const';
var NoStoreList = function (_a) {
    var no_stores = _a.no_stores;
    var rows = useState(10)[0];
    return (React.createElement(Grid, { data: no_stores, columns: [
            {
                id: 'id',
                name: 'ID',
                hidden: true,
            },
            {
                id: 'parent_cd',
                name: 'NOコード',
                width: '100px',
                formatter: function (cell, row) {
                    return _(React.createElement("a", { className: "link-text", href: "" + location.origin + process.env.MIX_MOCK_URL + "/staff/no_store/update/" + row.cells[no_store_list_index.id].data }, "" + row.cells[no_store_list_index.parent_cd].data));
                },
            },
            {
                id: 'no_cd',
                name: '販売店コード',
                width: '120px',
            },
            {
                id: 'no_name',
                name: '販売店名',
                width: '120px',
            },
        ], fixedHeader: true, height: "600px" }));
};
export default memo(NoStoreList);
